<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>

    <!-- 搜索区域：跟进模式 -->
    <el-form v-show="activeTab !== 'billSearch'" inline class="search-header" :model="searchData">
      <el-form-item label="关键字" class="kw">
        <el-input
          placeholder="请输入"
          v-model="searchData.keywordValue"
          class="input-with-select"
          size="small"
        >
          <el-select
            v-model="searchData.keywordName"
            slot="prepend"
            placeholder="请选择"
            size="small"
            style="width: 150px"
          >
            <el-option
              v-for="item in searchTypeOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-input>
      </el-form-item>
      <el-form-item label="客服">
        <el-input
          placeholder="请输入"
          size="small"
          style="width: 180px"
          v-model="searchData.kfUserName"
        ></el-input>
      </el-form-item>
      <el-form-item label="是否延期">
        <el-select
          style="width: 180px"
          v-model="searchData.isDelayLock"
          placeholder="请选择"
          size="small"
          clearable
        >
          <el-option label="否" :value="0"> </el-option>
          <el-option label="是" :value="1"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="待还首期">
        <el-select
          style="width: 180px"
          v-model="searchData.isFupBill"
          placeholder="请选择"
          size="small"
          clearable
        >
          <el-option label="否" :value="0"> </el-option>
          <el-option label="是" :value="1"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否特批">
        <el-select v-model="searchData.isForceApprove" placeholder="请选择" size="small" clearable>
          <el-option label="否" :value="false"></el-option>
          <el-option label="是" :value="true"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-button
          @click="getList"
          type="primary"
          icon="el-icon-search"
          size="small"
          >查询</el-button
        >
        <el-button
          @click="reset"
          size="small"
          type="info"
          icon="el-icon-refresh"
          >重置</el-button
        >
      </el-form-item>
    </el-form>

    <!-- 搜索区域：账单搜索模式 -->
    <el-form v-show="activeTab === 'billSearch'" inline class="search-header" :model="billSearchData">
      <el-form-item label="订单号">
        <el-input
          placeholder="请输入订单号"
          v-model="billSearchData.orderNo"
          size="small"
          style="width: 200px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="客户姓名">
        <el-input
          placeholder="请输入客户姓名"
          v-model="billSearchData.memberName"
          size="small"
          style="width: 180px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input
          placeholder="请输入手机号"
          v-model="billSearchData.memberMobile"
          size="small"
          style="width: 180px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-button
          @click="getBillSearchList"
          type="primary"
          icon="el-icon-search"
          size="small"
        >查询</el-button
        >
        <el-button
          @click="resetBillSearch"
          size="small"
          type="info"
          icon="el-icon-refresh"
        >重置</el-button
        >
      </el-form-item>
    </el-form>

    <el-divider></el-divider>

    <!-- 导出按钮（仅跟进模式显示） -->
    <div class="export-btn" v-show="activeTab !== 'billSearch'">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-download"
        @click="downloadExcel"
      >导出</el-button
      >
    </div>

    <!-- 统一 tabs：待跟进 / 已完成跟进 / 账单搜索 -->
    <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane label="待跟进" name="0"></el-tab-pane>
      <el-tab-pane label="已完成跟进" name="1"></el-tab-pane>
      <el-tab-pane label="账单搜索" name="billSearch"></el-tab-pane>
    </el-tabs>

    <!-- 跟进模式表格 -->
    <tp-table
      v-show="activeTab !== 'billSearch'"
      :isCheckBox="false"
      :tableData="list"
      :columns="columns"
      :totalNum="total"
      :current-page.sync="currentPage"
      :pageSize.sync="pageSize"
    />

    <!-- 账单搜索表格 -->
    <div v-show="activeTab === 'billSearch'">
      <tp-table
        v-if="billSearchLoaded"
        :isCheckBox="false"
        :tableData="billSearchList"
        :columns="billSearchColumns"
        :totalNum="billSearchTotal"
        :current-page.sync="billSearchCurrentPage"
        :pageSize.sync="billSearchPageSize"
      />
      <div v-else class="empty-tip">请输入搜索条件后查询</div>
    </div>

    <!-- 跟进记录组件 -->
    <FollowUpRecord
      :visible.sync="followUpRecordVisible"
      :order-info="currentBill"
      :show-add-form="false"
      @success="handleFollowUpRecordSuccess"
    />

    <!-- 完成跟进对话框 -->
    <el-dialog
      title="跟进记录"
      :visible.sync="followUpDialogVisible"
      width="600px"
      @open="handleFollowUpDialogOpen"
    >
      <el-form ref="followUpForm" :model="followUpForm" label-width="120px">
        <el-form-item label="跟进记录" prop="content">
          <el-input
            type="textarea"
            :rows="6"
            v-model="followUpForm.content"
            placeholder="请输入跟进记录"
          ></el-input>
        </el-form-item>
        <el-form-item label="下次跟进日期" prop="nextFollowUpDate">
          <el-date-picker
            v-model="followUpForm.nextFollowUpDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            style="width: 100%"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="followUpDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitFollowUp">完成</el-button>
      </div>
    </el-dialog>

    <!-- 账单管理组件 -->
    <BillManage
      :visible.sync="billManageVisible"
      :order-no="billManageOrderNo"
      @success="handleBillManageSuccess"
    />
  </div>
</template>

<script>
import { authBtnMixin } from "@/mixins/authBtnMixin";
import {
  getListAPI,
  completeFollowUpAPI,
  exportAPI,
  searchBillAPI,
} from "./api";
import FollowUpRecord from "../components/follow-up-record.vue";
import BillManage from "../components/bill-manage.vue";

export default {
  name: "TodayFollowUp",
  mixins: [authBtnMixin],
  components: {
    FollowUpRecord,
    BillManage,
  },
  data() {
    return {
      activeTab: "0", // 0: 待跟进, 1: 已完成跟进, billSearch: 账单搜索
      // ---- 今日待跟进 ----
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        keywordName: "orderNo",
        keywordValue: "",
        kfUserName: "",
        isDelayLock: null,
        isFupBill: null,
        isForceApprove: null,
      },
      searchTypeOptions: [
        { name: "订单号", value: "orderNo" },
        { name: "客户姓名", value: "memberName" },
        { name: "客户手机号", value: "memberMobile" },
        { name: "门店跟进人", value: "storeBusinessUserName" },
        { name: "审核", value: "reviewUserName" },
      ],
      followUpDialogVisible: false,
      followUpForm: {
        billId: "",
        orderNo: "",
        content: "",
        nextFollowUpDate: "",
      },
      followUpRecordVisible: false,
      currentBill: null,
      pickerOptions: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() <= today.getTime();
        },
      },
      // ---- 账单搜索 ----
      billSearchData: {
        orderNo: "",
        memberName: "",
        memberMobile: "",
      },
      billSearchList: [],
      billSearchTotal: 0,
      billSearchCurrentPage: 1,
      billSearchPageSize: 10,
      billSearchLoaded: false,
      // ---- 账单管理 ----
      billManageVisible: false,
      billManageOrderNo: "",
    };
  },
  provide() {
    return {
      context: this,
    };
  },
  mounted() {
    this.getList();
  },
  watch: {
    currentPage() {
      if (this.activeTab !== "billSearch") {
        this.getList();
      }
    },
    pageSize() {
      if (this.activeTab !== "billSearch") {
        this.getList();
      }
    },
    billSearchCurrentPage() {
      if (this.billSearchLoaded) {
        this.getBillSearchList();
      }
    },
    billSearchPageSize() {
      if (this.billSearchLoaded) {
        this.getBillSearchList();
      }
    },
  },
  computed: {
    // 数据列（不含操作列）
    dataColumns() {
      return [
        {
          label: "用户信息",
          prop: "member",
          minWidth: "180",
          customRender(h, row) {
            return (
                <div>
                  <div>姓名：{row["memberName"] || ""}</div>
                  <div>手机号：{row["memberMobile"] || ""}</div>
                </div>
            );
          },
        },
        {
          label: "客服",
          prop: "kfUser",
          minWidth: "100",
          customRender(h, row) {
            return <p>{row["kfUserName"] || ""}</p>;
          },
        },
        {
          label: "账单状态",
          prop: "billStatusName",
          minWidth: "100",
          customRender(h, row) {
            return <p>{row["billStatusName"] || ""}</p>;
          },
        },
        {
          label: "订单信息",
          prop: "order",
          minWidth: "280",
          customRender(h, row) {
            return (
                <div>
                  <div>
                    订单单号：{row["order"]?.["orderNo"] || row["orderNo"] || ""}
                  </div>
                  <div>下单时间：{row["order"]?.["createTime"] || ""}</div>
                  <div>
                    订单类型：
                    <el-tag type="warning" size="mini">
                      {row["order"]?.["orderTypeName"] || ""}
                    </el-tag>
                    <el-tag
                      type={row["isForceApprove"] ? "success" : "info"}
                      size="mini"
                    >
                      {row["isForceApprove"] ? "特批" : "非特批"}
                  </el-tag>
                  </div>
                  <div>订单挂账余额：¥{row["order"]?.["reserveAmount"] || 0}</div>
                </div>
            );
          },
        },
        {
          label: "门店信息",
          prop: "store",
          minWidth: "200",
          customRender(h, row) {
            return (
                <div>
                  <div>门店名称：{row["store"]?.["storeName"] || ""}</div>
                  <div>
                    门店跟进人：
                    {row["store"]?.["businessUserName"] ||
                        row["storeBusinessUserName"] ||
                        ""}
                  </div>
                </div>
            );
          },
        },
        {
          label: "设备监管信息",
          prop: "device",
          minWidth: "200",
          customRender(h, row) {
            return (
                <div>
                  <div>
                    锁机状态：
                    <el-tag
                        v-show={row["order"]["lockStatus"] == 0}
                        type="success"
                        size="mini"
                    >
                      未锁机
                    </el-tag>
                    <el-tag
                        v-show={row["order"]["lockStatus"] == 1}
                        type="warning"
                        size="mini"
                    >
                      待锁机
                    </el-tag>
                    <el-tag
                        v-show={row["order"]["lockStatus"] == 2}
                        type="danger"
                        size="mini"
                    >
                      已锁机
                    </el-tag>
                  </div>
                  <div>待锁机日期：{row["order"]?.["lockDate"] || ""}</div>
                  <div>设备状态：{row["order"]?.["deviceStatusName"] || ""}</div>
                </div>
            );
          },
        },
        {
          label: "期数",
          prop: "billNum",
          minWidth: "120",
          customRender(h, row) {
            return (
                <div>
                  <span>{row["billNum"] || ""}</span>
                  <el-tag
                      v-show={row["isFupBill"]}
                      style="margin-left:5px"
                      type="info"
                      size="mini"
                  >
                    待还首期
                  </el-tag>
                </div>
            );
          },
        },
        {
          label: "账单日",
          prop: "billDate",
          minWidth: "120",
          customRender(h, row) {
            return <p>{row["billDate"] || ""}</p>;
          },
        },
        {
          label: "租金",
          prop: "principalAmount",
          minWidth: "100",
          customRender(h, row) {
            return <p>{row["principalAmount"] || "0.00"}</p>;
          },
        },
        {
          label: "押金抵扣",
          prop: "depositPrice",
          minWidth: "100",
          customRender(h, row) {
            return <p>{row["depositPrice"] || "0.00"}</p>;
          },
        },
        {
          label: "待支付金额",
          prop: "leftPayAmount",
          minWidth: "100",
          customRender(h, row) {
            return <p>{row["leftPayAmount"] || "0.00"}</p>;
          },
        },
        {
          label: "审核",
          prop: "reviewUserName",
          minWidth: "100",
          customRender(h, row) {
            return <p>{row["reviewUserName"] || ""}</p>;
          },
        },
      ];
    },
    // 今日待跟进列 = 数据列 + 操作列（跟进记录/完成跟进/账单管理）
    columns() {
      return [
        ...this.dataColumns,
        {
          label: "操作",
          minWidth: "200",
          fixed: "right",
          customRender(h, row) {
            return (
                <div>
                  <el-link
                      underline={false}
                      type="primary"
                      style="margin-right: 10px"
                      onClick={() => this.showFollowUpRecord(row)}
                  >
                    跟进记录
                  </el-link>
                  <el-link
                      underline={false}
                      type="primary"
                      style="margin-right: 10px"
                      onClick={() => this.showFollowUpDialog(row)}
                      v-show={this.activeTab == "0"}
                  >
                    完成跟进
                  </el-link>
                  <el-link
                      underline={false}
                      type="primary"
                      onClick={() => this.handleBillManage(row)}
                      v-show={this.activeTab == "0"}
                  >
                    账单管理
                  </el-link>
                </div>
            );
          },
        },
      ];
    },
    // 账单搜索列 = 数据列 + 操作列（仅账单管理）
    billSearchColumns() {
      return [
        ...this.dataColumns,
        {
          label: "操作",
          minWidth: "100",
          fixed: "right",
          customRender(h, row) {
            return (
                <div>
                  <el-link
                      underline={false}
                      type="primary"
                      onClick={() => this.handleBillManage(row)}
                  >
                    账单管理
                  </el-link>
                </div>
            );
          },
        },
      ];
    },
  },
  methods: {
    // ---- 今日待跟进 ----
    async getList() {
      const params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        followStatus: parseInt(this.activeTab),
        kfUserName: this.searchData.kfUserName,
        isDelayLock: this.searchData.isDelayLock,
        isFupBill: this.searchData.isFupBill,
        isForceApprove: this.searchData.isForceApprove,
      };

      if (this.searchData.keywordName && this.searchData.keywordValue) {
        params[this.searchData.keywordName] = this.searchData.keywordValue;
      }

      try {
        const res = await getListAPI(params);
        this.list = res.list || [];
        this.total = res.total || 0;
      } catch (error) {
        console.error("获取列表失败:", error);
      }
    },
    reset() {
      this.searchData = {
        keywordName: "orderNo",
        keywordValue: "",
        kfUserName: "",
        isDelayLock: null,
        isFupBill: null,
        isForceApprove: null,
      };
      this.currentPage = 1;
      this.getList();
    },
    handleTabClick() {
      if (this.activeTab === "billSearch") {
        this.resetBillSearch();
      } else {
        this.currentPage = 1;
        this.getList();
      }
    },

    // ---- 账单搜索 ----
    async getBillSearchList() {
      const params = {
        page: this.billSearchCurrentPage,
        pageSize: this.billSearchPageSize,
        orderNo: this.billSearchData.orderNo,
        memberName: this.billSearchData.memberName,
        memberMobile: this.billSearchData.memberMobile,
      };

      try {
        const res = await searchBillAPI(params);
        this.billSearchList = res.list || [];
        this.billSearchTotal = res.total || 0;
        this.billSearchLoaded = true;
      } catch (error) {
        console.error("账单搜索失败:", error);
      }
    },
    resetBillSearch() {
      this.billSearchData = {
        orderNo: "",
        memberName: "",
        memberMobile: "",
      };
      this.billSearchList = [];
      this.billSearchTotal = 0;
      this.billSearchCurrentPage = 1;
      this.billSearchLoaded = false;
    },

    // ---- 跟进相关 ----
    showFollowUpDialog(row) {
      this.followUpForm = {
        billId: row.id,
        orderNo: row.orderNo,
        content: "",
        nextFollowUpDate: "",
      };
      this.$nextTick(() => {
        if (this.$refs.followUpForm) {
          this.$refs.followUpForm.clearValidate();
        }
      });
      this.followUpDialogVisible = true;
    },
    async submitFollowUp() {
      await this.$refs.followUpForm.validate();

      await completeFollowUpAPI({
        id: this.followUpForm.billId,
        followContent: this.followUpForm.content,
        nextFollowDate: this.followUpForm.nextFollowUpDate || "",
      });

      this.$message.success("完成跟进成功");
      this.followUpDialogVisible = false;
      this.getList();
    },
    showFollowUpRecord(row) {
      this.currentBill = row;
      this.followUpRecordVisible = true;
    },
    handleFollowUpRecordSuccess() {
      this.getList();
    },
    handleFollowUpDialogOpen() {
      this.$nextTick(() => {
        if (this.$refs.followUpForm) {
          this.$refs.followUpForm.clearValidate();
        }
      });
    },

    // ---- 账单管理 ----
    handleBillManage(row) {
      this.billManageOrderNo = row.orderNo || (row.order ? row.order.orderNo : "") || "";
      this.billManageVisible = true;
    },
    handleBillManageSuccess() {
      if (this.activeTab === "billSearch") {
        if (this.billSearchLoaded) this.getBillSearchList();
      } else {
        this.getList();
      }
    },

    // ---- 导出 ----
    async downloadExcel() {
      const params = {
        followStatus: parseInt(this.activeTab),
        kfUserName: this.searchData.kfUserName,
        isDelayLock: this.searchData.isDelayLock,
        isFupBill: this.searchData.isFupBill,
        isForceApprove: this.searchData.isForceApprove,
      };
      if (this.searchData.keywordName && this.searchData.keywordValue) {
        params[this.searchData.keywordName] = this.searchData.keywordValue;
      }
      exportAPI(params);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  .el-divider--horizontal {
    margin: 0 0 20px;
  }
}

.search-header {
  .kw {
    ::v-deep {
      .input-with-select {
        vertical-align: middle;
      }
      .input-with-select .el-input-group__prepend {
        background-color: #fff;
      }
    }
  }
}

.export-btn {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.empty-tip {
   text-align: center;
   color: #909399;
   padding: 60px 0;
   font-size: 14px;
 }

.follow-up-info {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;

  .info-item {
    margin-bottom: 10px;
    font-size: 14px;

    .label {
      font-weight: 600;
      color: #606266;
    }
  }
}
</style>
